import {DescriptionText, H1Text, H2Text} from "../../../design";
import currencyFormatter from "../../../utils/currencyformatter";
import {AmountDivideByHundred} from "../../../helper";
import React from "react";

type Props = {
  order: Object
}

const WooCommerceLeftSideContent = (props:Props) => {
  const {order} = props;
  return (
    <>
      {order && <div>
        <H1Text>
          Payment Checkout
        </H1Text>
        {
          order.orderId  && <H2Text>
            Payment For
          </H2Text>
        }
        {order.orderId  && <DescriptionText>
          Ecwid order id #{order && order.orderId}
        </DescriptionText>}
        {(order.amount && order.currency) && <H2Text>
          Amount Payable
        </H2Text>}
        <DescriptionText fontSize="24px">
          {(order.amount && order.currency) ? `${currencyFormatter(AmountDivideByHundred(order.amount), order.currency)}` : null}
        </DescriptionText>
      </div>}
    </>
  )
};

export default WooCommerceLeftSideContent
